var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',_vm._g({ref:"editable",staticClass:"py-2 px-1 mt-1",staticStyle:{"min-height":"35px","outline-color":"transparent"},attrs:{"contenteditable":""}},_vm.listeners))}
var staticRenderFns = []

export { render, staticRenderFns }